import { useUser } from "../../../context/UserContext";
import SpeakerEventCard from "./components/SpeakerEventCard";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import AddNewEventForModalForm from "../../../components/AddNewEventForUser/AddNewEventForModalForm";
import AddNewEventForUserButton from "../../../components/AddNewEventForUser/AddNewEventForUserButton";
import { Link } from "@tanstack/react-router";
import PullToRefresh from "react-simple-pull-to-refresh";
import {
  useRealtimeAllUserEvents,
  useRealtimeUsers,
} from "../../../hooks/useRealtimeData";

export default function MySpeakers() {
  const { selectedYear } = useUser();
  const [openNewEvent, setOpenNewEvent] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const {
    events: data,
    loading: isLoading,
    error,
  } = useRealtimeAllUserEvents(selectedYear, selectedUserId);

  const { users, loading: usersLoading } = useRealtimeUsers();

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="container mx-auto flex flex-col py-2 pb-20">
        <div className="text-center text-red-500 py-10">Σφάλμα: {error}</div>
      </div>
    );
  }

  return (
    <PullToRefresh onRefresh={() => window.location.reload()}>
      <div className="container mx-auto flex flex-col py-2 pb-20">
        <Link to="/dashboard" className={"p-2 inline-flex items-center gap-2"}>
          <ArrowLeftIcon className={"size-5"} /> Πίσω
        </Link>

        <div className="h-full flex flex-col ring-1 rounded-2xl overflow-hidden ring-gray-300 m-2">
          <div className="bg-white text-lg text-gray-900 font-bold px-5 py-2 shadow border-b border-gray-300">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <span>Όλες οι ομιλίες - {data?.length}</span>
              <div className="flex items-center gap-2 w-full sm:w-auto">
                <select
                  value={selectedUserId || ""}
                  onChange={(e) => setSelectedUserId(e.target.value || null)}
                  className="text-sm border border-gray-300 rounded-md px-3 py-1 focus:outline-none flex-1 sm:flex-none min-w-0"
                  disabled={usersLoading}
                >
                  <option value="">Όλοι οι χρήστες</option>
                  {users?.map((user) => (
                    <option key={user.id} value={user.uid}>
                      {user.fullname || user.email}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="h-full bg-white">
            <table className="w-full">
              <tbody>
                {data?.length === 0 && (
                  <tr>
                    <td className="text-center text-gray-500 py-10">
                      Δεν έχετε ομιλίες
                    </td>
                  </tr>
                )}

                {data?.map((event, index) => (
                  <SpeakerEventCard event={event} key={index} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <AddNewEventForUserButton setOpen={setOpenNewEvent} isOne={true} />
        <AddNewEventForModalForm
          open={openNewEvent}
          setOpen={setOpenNewEvent}
        />
      </div>
    </PullToRefresh>
  );
}
